import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';
import BaseTypeSelectorFactory from '@/Factories/ControlFactories/BaseTypeSelectorFactory';
import AssociationBoxViewModel from '@/ViewModels/Controls/AssociationBoxViewModel';

export default class PDJobUIListener extends UIListener {

    constructor() {
        super();
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string) {
        if (property !== 'SendEmail') {
            return;
        }

        this.updateNotification(context);
    }

    public onDetailViewReady(context: DetailViewContext) {
        this.updateType(context);
        this.updateNotification(context);
    }

    public onAssociationUpdated(context: DetailViewContext, relation: string) {
        if (relation != 'Type') {
            return;
        }

        this.updateType(context);
    }

    private updateType(context: DetailViewContext): void {
        let typeViewModel = (context.getUIFactory('Type') as ControlFactory).viewModel as AssociationBoxViewModel;
        let objectFactory = context.getUIFactory('Object') as BaseTypeSelectorFactory;

        objectFactory.pdTypeName = typeViewModel.textBox.value();
    }

    private updateNotification(context: DetailViewContext): void {
        let notifyUsers = context.genericObject.getObservable('SendEmail');

        if (notifyUsers() === true) {
            (context.getUIFactory('EmailNotification') as ControlFactory).isVisible(true);
        } else {
            (context.getUIFactory('EmailNotification') as ControlFactory).isVisible(false);
        }
    }
}

ComponentManager.setUIListener('PDJobUIListener', PDJobUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.PDJobUIListener', PDJobUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');